module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-AGENCIA.f9f2a5ae.png";